module.exports = __webpack_public_path__ + "static/media/YOGA2022Logo.2e8f845b.svg";